// assets/js/components/revenue-calculator/validate.js
//
// Input checks shared by the steps. The min/max on <input type="number"> are only
// hints to the browser — users can still type "-5" — so every step re-checks here.
// Upper bounds mirror the lead API's DTO ranges (SubmitLeadRequestDTO): a value
// the backend would reject must be caught before the lead gate, because the
// POST is fire-and-forget and a rejected lead is otherwise lost silently.

function isBlank(v) {
    return v == null || String(v).trim() === "";
}

// rule: { key, id, min, max, integer, optional }
function numberError(value, rule) {
    if (isBlank(value)) return rule.optional ? "" : _t("Please fill in all required fields.");
    var n = Number(value);
    if (!isFinite(n) || n < rule.min || n > rule.max || (rule.integer && Math.floor(n) !== n)) {
        return (rule.integer ? _t("Please enter a whole number between %min% and %max%.") : _t("Please enter a number between %min% and %max%."))
            .replace("%min%", String(rule.min)).replace("%max%", String(rule.max));
    }
    return "";
}

// Returns { id, message } for the first failing rule, or null when all pass.
function firstNumberError(d, rules) {
    for (var i = 0; i < rules.length; i++) {
        var message = numberError(d[rules[i].key], rules[i]);
        if (message) return { id: rules[i].id, message: message };
    }
    return null;
}

// Deliberately loose (one "@", a dot in the domain, no spaces) — the backend's
// Assert\Email is the authority; this only stops obvious typos like "abc".
function isEmail(v) {
    return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(String(v || "").trim());
}

module.exports = { isBlank: isBlank, numberError: numberError, firstNumberError: firstNumberError, isEmail: isEmail };
